import ApiCaller from "../../Connection/ApiCaller";

const API_ListPatientForLocation = async (data) => {
    return await ApiCaller.post("/Statistic/ListPatientForLocation",data);
};

const API_ReportTicked_Base64 = (data) => {
    return ApiCaller.post(
      `/ReportSample/ReportTicked_Base64`,
      data,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
      true
    );
  };

export{
    API_ListPatientForLocation,
    API_ReportTicked_Base64
}